import JarvisInfoContainer from "./JarvisInfoContainer";
import JarvisInfoStore from "./JarvisInfoStore";

export default JarvisInfoStore(JarvisInfoContainer);